import { render } from "./WelcomeBeautySalon.vue?vue&type=template&id=0b3cec6c&scoped=true&ts=true"
import script from "./WelcomeBeautySalon.vue?vue&type=script&lang=ts"
export * from "./WelcomeBeautySalon.vue?vue&type=script&lang=ts"

import "./WelcomeBeautySalon.vue?vue&type=style&index=0&id=0b3cec6c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b3cec6c"]])

export default __exports__